import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";

interface Announcement {
  id: string;
  title: string;
  content: string;
}

interface AnnouncementPopupProps {
  announcement: Announcement | null;
}

export function AnnouncementPopup({ announcement }: AnnouncementPopupProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (announcement) {
      const hasSeenAnnouncement = sessionStorage.getItem(`announcement-${announcement.id}`);
      if (!hasSeenAnnouncement) {
        setOpen(true);
      }
    }
  }, [announcement]);

  const handleClose = () => {
    if (announcement) {
      sessionStorage.setItem(`announcement-${announcement.id}`, "true");
    }
    setOpen(false);
  };

  if (!announcement) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5 text-primary" />
            {announcement.title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="text-sm text-muted-foreground whitespace-pre-line">
            {announcement.content}
          </div>
          <Button onClick={handleClose} className="w-full gradient-primary text-primary-foreground border-0">
            Tutup
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
